export default {
  container: {
    width: '100%',
    paddingBottom: '.8rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/FovPreview/style.js